import React from "react";

import LoadingPlan from "QuotePage/app/LoadingPlan";
import { PlanCard } from "QuotePage/Components/PlanCard";
import { StartApplicationButton, MoreDetailsButton } from "QuotePage/Components/PlanCardButtons";
import { connect } from "react-redux";

import MultiplePlansCard from "../shared/MultiplePlansCard";
import { getPlanById } from "Common/PlanLoader/Selectors";

type Props = {
  plans: Array<Record<string, any>>;
  plansLoaded: Array<Record<string, any>>;
};

export const CustomVisiblePlansDumb = ({ plans, plansLoaded }: Props) => (
  <>
    {plans.map((plan, step) => (
      <React.Fragment key={step}>
        {plan.id === "multiple_plans" ? (
          <MultiplePlansCard customRecommendation={plan.message} firstRecommendation={step === 0} position={step + 1} />
        ) : !plansLoaded[step] ? (
          <LoadingPlan />
        ) : (
          <PlanCard key={plan.id} planId={plan.id} recommendationType={step === 0 ? "bestMatch" : undefined}>
            <MoreDetailsButton planId={plan.id} />
            <StartApplicationButton planId={plan.id} />
          </PlanCard>
        )}
      </React.Fragment>
    ))}
  </>
);

const mapStateToProps = (state) => ({
  plans: state.recommendedPlans,
  plansLoaded: [
    getPlanById(state, state.recommendedPlans[0].id),
    getPlanById(state, state.recommendedPlans[1].id),
    getPlanById(state, state.recommendedPlans[2].id),
    getPlanById(state, state.recommendedPlans[3].id),
  ],
});

export default connect(mapStateToProps)(CustomVisiblePlansDumb);
